import queryString from 'query-string';
import { useMemo } from 'react';
import { useSearch } from 'wouter';

export default function useSourceFromQuery(): string | null {
    const search = useSearch();
    return useMemo<string | null>(() => {
        const {
            source: sourceQuery = null,
            utm_medium: utmMedium,
            utm_campaign: utmCampaign = null,
        } = queryString.parse(search) || {};
        const utmSourceQuery =
            utmMedium !== null
                ? [utmMedium, utmCampaign]
                      .filter((it) => it !== null)
                      .map((it) => (Array.isArray(it) ? it[0] : it))
                      .join(':')
                : null;
        return (
            (Array.isArray(sourceQuery) ? sourceQuery[0] : sourceQuery) || utmSourceQuery || null
        );
    }, [search]);
    return;
}
